import { render, staticRenderFns } from "./teamDirectoryListing.vue?vue&type=template&id=95914d90&scoped=true&"
import script from "./teamDirectoryListing.vue?vue&type=script&lang=js&"
export * from "./teamDirectoryListing.vue?vue&type=script&lang=js&"
import style0 from "./teamDirectoryListing.vue?vue&type=style&index=0&id=95914d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95914d90",
  null
  
)

export default component.exports